import * as Middleware from '@/Middleware';
import Store from '@/Store';
import Vue from 'vue';
import VueRouter, { NavigationGuard, RawLocation, Route, RouteConfig } from 'vue-router';

// Attach VueRouter
// -----------------------------------------------------------------------------

Vue.use(VueRouter);

// Define Routing
// -----------------------------------------------------------------------------

export const unauthenticatedRoutes: string[] = ['PageHome', 'PageLogout', 'PageLogin', 'PageTrainer'];

const routes: Array<RouteConfig> = [
	{
		component: () => import(/* webpackChunkName: "page-trainer" */ '@/App/Page/Trainer.vue'),
		name: 'PageTrainer',
		path: '/',
	},
	{
		component: () => import('@/App/Page/Home.vue'),
		name: 'PageHome',
		path: '/home',
	},
	{
		component: () => import('@/App/Page/Logout.vue'),
		name: 'PageLogout',
		path: '/logout',
	},
	{
		component: () => import('@/App/Page/Styleguide.vue'),
		name: 'PageStyleguide',
		path: '/styleguide',
	},
	{
		path: '*',
		redirect: '/',
	},
];

// Setup Router
// -----------------------------------------------------------------------------

const router = new VueRouter({
	base: process.env.BASE_URL,
	mode: 'history',
	routes: routes,
});

export default router;

// Middleware hooks
// ---------------------------------------------------------------------------

const middlewares: NavigationGuard[] = [Middleware.QueryParameters, Middleware.Authentication, Middleware.ScrollToTop];

middlewares.forEach((middleware: NavigationGuard) => router.beforeEach(middleware));
